import React, { Component } from 'react'
import { TextField, InputAdornment } from '@material-ui/core'

export class Name extends Component {
  render() {
    return (
      <div>
        <TextField
          style={{
            margin: '6px'
          }}
          label="First Name"
          value={(this.props.firstname && this.props.firstname) || ''}
          name="firstname"
          id="firstname"
          margin="dense"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </InputAdornment>
            )
          }}
          required
          autoComplete="false"
          onChange={this.props.onChange}
        />
        <TextField
          style={{
            margin: '6px'
          }}
          label="Last Name"
          name="lastname"
          id="lastname"
          value={(this.props.lastname && this.props.lastname) || ''}
          type="text"
          margin="dense"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </InputAdornment>
            )
          }}
          required
          autoComplete="false"
          onChange={this.props.onChange}
        />
      </div>
    )
  }
}
export default Name
